import { AUTH_TOKEN_LS_KEY } from "@tt-app/models";

export const isUserAuthenticated = (): boolean => {
  return localStorage.getItem(AUTH_TOKEN_LS_KEY) !== null;
};

export const validatePassword = (password: string) => {
  if (password.length < 8 || password.length > 64) {
    return "user.authentication.error.passwords.short";
  }

  if (!password.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/)) {
    return "user.authentication.error.passwords.fullWidth";
  }

  if (!password.match(/^[a-zA-Z0-9]+$/)) {
    return "user.authentication.error.passwords.specialCharacters";
  }

  if (!password.match(/[a-zA-Z]+/)) {
    return "user.authentication.error.passwords.letter";
  }

  if (!password.match(/[0-9]+/)) {
    return "user.authentication.error.passwords.number";
  }
};
